import './hero.css'
import {Link} from 'react-router-dom'

function Hero() {
    return (
        <div className='hero'>
             <img src={require('../../assets/house1.jpg')} alt=''/>
             <div className='containerInfo'>
                 <h1>KENYA RENTAL | BUSINESS HOUSES</h1>
                 <span className='desc'>
                     We have upto 40 rentals and business houses within Nakuru and the outskirts of Nakuru .
                     There is sufficient supply of water and electricity. Security is guaranteed and the environment is free from pollution . 
                 </span>
                 <div className="buttons">
                     <button className='contact'>
                         <i class="fas fa-phone-alt"></i>
                         <span  >
                         <a href='tel:+254742068914' className='link'>Connect</a></span>
                     </button>
                     <button className='discover'>
                         <i class="fas fa-angle-double-right"></i>
                      <Link to='/blog' className='link'><span>Discover</span></Link>   
                     </button>
                 </div>
             </div>
        </div>
    )
}

export default Hero
